import Cookies from "js-cookie";
import { useStoreState } from "../store/useStore";
import useFetch from "./useFetch";

const useLogout = () => {
  const { localeLink, baseUrl } = useStoreState();

  const { post } = useFetch(baseUrl);

  const logOutUser = async () => {
    return post(`uapi/v1/uc/log_out`);
  };

  const logout = async () => {
    await logOutUser();
    Cookies.remove("token");
    Cookies.remove("Global-UserViewType");
    Cookies.remove("Global-AccountType");
    window.location.href = `${localeLink}/login`;
  };

  return {
    logout
  };
};

export default useLogout;
